export enum LsValueType {
  token = 'token',
  exp = 'exp',
  locale = 'locale',
  realTimeConfig = 'realTimeConfig',
  secret = 'secret',
  transport_id = 'transport_id',
  provisioning_data_new_organisation = 'provisioning_data_new_organisation',
}
